import React from 'react';

export default function CheckIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={props.width ?? '25'}
      height={props.height ?? '25'}
      {...props}
    >
      <path
        d="M4.44141 11.6171L10.2864 17.4621L20.2094 7.53906"
        stroke={props.stroke ?? '#1a1a1a'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
